module.exports = __webpack_public_path__ + "static/media/collapse-sidebar.8007b21f.svg";